import { useState, useCallback, useRef, useEffect } from "react";
import { ActiveSelect } from "../../common/constants";

/**
 * Custom hook for managing navigation state
 */
export const useNavigation = (initialType = ActiveSelect.HOME) => {
  const [type, setType] = useState(initialType);
  const [detailUUID, setDetailUUID] = useState("");
  const [editTow, setEditTow] = useState(null);
  const [lastPositionY, setLastPositionY] = useState(0);
  // Use ref to store scroll position immediately (before React state update)
  const lastPositionYRef = useRef(0);

  const setNavigationType = useCallback((newType) => {
    setType(newType);
  }, []);

  // Update ref when state changes
  useEffect(() => {
    lastPositionYRef.current = lastPositionY;
  }, [lastPositionY]);

  const selectHome = useCallback((contentRef, lastY) => {
    // Use ref value if lastY is 0 but ref has a value (state might not have updated yet)
    const scrollPos = (lastY !== undefined && lastY !== null && lastY >= 0) ? lastY : lastPositionYRef.current;
    
    setNavigationType(ActiveSelect.HOME);
    
    if (scrollPos > 0) {
      // Simple approach: wait for DOM to update, then scroll using DOM directly
      setTimeout(() => {
        // Try contentRef first if available
        if (contentRef?.current) {
          try {
            contentRef.current.scrollToPoint(0, scrollPos, 0);
            return;
          } catch (err) {
            // Fall through to DOM method
          }
        }
        
        // Fallback: use DOM query to find and scroll the element directly
        const scrollElements = document.querySelectorAll('ion-content main.inner-scroll');
        if (scrollElements.length > 0) {
          scrollElements[0].scrollTo({ top: scrollPos, behavior: 'auto' });
        }
      }, 200);
    }
  }, [setNavigationType]);

  // Helper to set position and ref simultaneously
  const setLastPositionYWithRef = useCallback((position) => {
    lastPositionYRef.current = position;
    setLastPositionY(position);
  }, []);

  return {
    type,
    detailUUID,
    editTow,
    lastPositionY,
    setNavigationType,
    setDetailUUID,
    setEditTow,
    setLastPositionY: setLastPositionYWithRef,
    selectHome
  };
};

